<mat-toolbar color="primary">
  <mat-toolbar-row>
    <span>{{ 'modals.modal-survey-revision-preview.title' | translate }}</span>
    <span class="spacer"></span>
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </mat-toolbar-row>
</mat-toolbar>

<div mat-dialog-content class="m-5">
  <!-- Version Change Header -->
  <div class="row mb-4 justify-content-center align-items-center">
    <div class="col-auto">
      <div class="d-flex align-items-center p-3 rounded bg-light shadow-sm">
        <div class="text-center mx-3">
          <div class="text-muted small text-uppercase">{{ 'generic.session' | translate }}</div>
          <div class="h4 mb-0 font-weight-bold">{{ data.current_session_number }}</div>
        </div>
        <mat-icon class="mx-3 text-muted">arrow_forward</mat-icon>
        <div class="text-center mx-3">
          <div class="text-muted small text-uppercase">{{ 'generic.new-session' | translate }}</div>
          <div class="h4 mb-0 font-weight-bold text-primary">{{ data.next_session_number }}</div>
        </div>
      </div>
    </div>
  </div>

  <!-- Stats Cards -->
  <div class="row mb-4">
    <div class="col-md-3 col-6 mb-3">
      <mat-card class="h-100 text-center stat-card">
        <mat-card-content>
          <div class="h2 mb-0 font-weight-bold">{{ data.stats.total }}</div>
          <div class="text-muted small">{{
              'modals.modal-survey-revision-preview.total-questions' | translate
            }}
          </div>
        </mat-card-content>
      </mat-card>
    </div>
    <div class="col-md-3 col-6 mb-3">
      <mat-card class="h-100 text-center stat-card border-success-left">
        <mat-card-content>
          <div class="h2 mb-0 font-weight-bold text-success">{{ data.stats.will_be_included_in_revision }}
          </div>
          <div class="text-muted small">{{ 'modals.modal-survey-revision-preview.included' | translate }}
          </div>
        </mat-card-content>
      </mat-card>
    </div>
    <div class="col-md-3 col-6 mb-3">
      <mat-card class="h-100 text-center stat-card border-danger-left">
        <mat-card-content>
          <div class="h2 mb-0 font-weight-bold text-danger">{{ data.stats.will_be_excluded_from_revision }}
          </div>
          <div class="text-muted small">{{ 'modals.modal-survey-revision-preview.excluded' | translate }}
          </div>
        </mat-card-content>
      </mat-card>
    </div>
    <div class="col-md-3 col-6 mb-3">
      <mat-card class="h-100 text-center stat-card border-warning-left">
        <mat-card-content>
          <div class="h2 mb-0 font-weight-bold text-warning">{{ data.stats.undecided }}</div>
          <div class="text-muted small">{{ 'modals.modal-survey-revision-preview.undecided' | translate }}
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>

  <!-- Questions Lists -->
  <div class="row">
    <!-- Included Questions -->
    <div class="col-md-6 mb-3">
      <div class="d-flex align-items-center mb-3">
        <mat-icon class="text-success mr-2">check_circle</mat-icon>
        <h3 class="mb-0">{{ 'modals.modal-survey-revision-preview.included-questions' | translate }}</h3>
      </div>
      <mat-card class="p-0 scrollable-list-container">
        <mat-list>
          <ng-container *ngFor="let q of data.included_questions; let last = last">
            <mat-list-item class="p-1 py-2">
              <mat-icon mat-list-icon [ngStyle]="{'color': surveyService.getDecisionColor(q.final_decision)}">
                {{ surveyService.getDecisionIcon(q.final_decision) }}
              </mat-icon>
              <div mat-line class="font-weight-bold">{{ q.question }}</div>
              <div mat-line class="text-muted small">
                {{
                  'service.survey-service.question-final-decision-statuses.' + q.final_decision +
                  '.title' | translate
                }}
              </div>
            </mat-list-item>
            <mat-divider *ngIf="!last"></mat-divider>
          </ng-container>
          <div *ngIf="data.included_questions.length === 0" class="p-4 text-center text-muted font-italic">
            {{ 'modals.modal-survey-revision-preview.no-questions' | translate }}
          </div>
        </mat-list>
      </mat-card>
    </div>

    <!-- Excluded Questions -->
    <div class="col-md-6 mb-3">
      <div class="d-flex align-items-center mb-3">
        <mat-icon class="text-danger mr-2">cancel</mat-icon>
        <h3 class="mb-0">{{ 'modals.modal-survey-revision-preview.excluded-questions' | translate }}</h3>
      </div>
      <mat-card class="p-0 scrollable-list-container">
        <mat-list>
          <ng-container *ngFor="let q of data.excluded_questions; let last = last">
            <mat-list-item class="p-1 py-2">
              <mat-icon mat-list-icon [ngStyle]="{'color': surveyService.getDecisionColor(q.final_decision)}">
                {{ surveyService.getDecisionIcon(q.final_decision) }}
              </mat-icon>
              <div mat-line
                   class="font-weight-bold"
                   [ngClass]="{
                  'text-muted line-through': q.final_decision === 'rejected'
               }">
                {{ q.question }}
              </div>

              <div mat-line class="text-muted small">
                {{
                  'service.survey-service.question-final-decision-statuses.' + q.final_decision +
                  '.title' | translate
                }}
              </div>
            </mat-list-item>
            <mat-divider *ngIf="!last"></mat-divider>
          </ng-container>
          <div *ngIf="data.excluded_questions.length === 0" class="p-4 text-center text-muted font-italic">
            {{ 'modals.modal-survey-revision-preview.no-questions' | translate }}
          </div>
        </mat-list>
      </mat-card>
    </div>
  </div>
</div>

<div mat-dialog-actions align="center" class="mt-5 mb-2">
  <button mat-button (click)="close()">
    {{ 'generic.buttons.close' | translate }}
  </button>
  <button mat-raised-button color="primary" (click)="confirmRevision()">
    <mat-icon>save</mat-icon>
    {{ 'modals.modal-survey-revision-preview.confirm-revision' | translate }}
  </button>
</div>
